import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowBack from "../assets/icons/arrow_back.svg";
import notionService from '../services/notion.service';

const NotionPrinciplesPage = () => {
  const { t } = useTranslation();
  const page_id = '2f1b9739666b4bef9dfd84dce9ba31ff';
  const [pageData, setPageData] = useState(null);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await notionService.getPageContent(page_id);
        const data = response.data;
        if (data && data.page && data.blocks) {
          setPageData(data.page);
          setBlocks(Array.isArray(data.blocks.results) ? data.blocks.results : []);
        } else {
          console.error("Datos de la página o bloques no encontrados en la respuesta");
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
      }
    };
  
    fetchPageData();
  }, []);  
  
  const renderRichText = (richTextArray) => {
    return richTextArray.map((richTextElement, index) => {
      // Verifica si el texto es en negrita
      if (richTextElement.annotations && richTextElement.annotations.bold) {
        return <strong key={index} className='text-shaiaBlue'>{richTextElement.plain_text}</strong>;
      }
      // Renderiza normal si no es en negrita
      return <span key={index}>{richTextElement.plain_text}</span>;
    });
  };

  return (
    <>
      <div className="back-button">
        <Link to={"/"} className="back-button_arrow">
          <img src={ArrowBack} alt="" /> {t("inicio")}
        </Link>
        <span className="back_button_root">Shaia /</span>
        <span className="back_button_page">Principios</span>
      </div>
      <div className="wrapper">
        <div className="main_board page">
          <div className="main_board-body">
            <div className={`main_cover_notion`}>
              {pageData?.cover && (
                <img src={pageData.cover.file.url} alt="Cover" />
              )}
            </div>
            <div className='px-60 sm-max:px-0 text-Grey-500 sm-max:overflow-x-hidden'>
              {blocks && blocks.map(block => {
                switch (block.type) {
                  case 'paragraph':
                    return <p key={block.id} className='text-4.5'>{renderRichText(block.paragraph.rich_text)}</p>;
                  case 'numbered_list_item':
                    return (
                      <ul key={block.id} className='list-disc pl-16'>
                        <li className='text-4.5 mb-4'>{renderRichText(block.numbered_list_item.rich_text)}</li>
                      </ul>
                    );          
                  case 'heading_1':
                    return <h2 key={block.id} className='text-Grey-500 mb-4 mt-8 text-6'>{renderRichText(block.heading_1.rich_text)}</h2>;
                  case 'heading_2':
                    return <h3 key={block.id} className='text-Grey-500 mb-4 mt-8 text-5.5'>{renderRichText(block.heading_2.rich_text)}</h3>;
                  case 'heading_3':
                    return <h4 key={block.id} className='text-Grey-500 mb-4 mt-8 text-5'>{renderRichText(block.heading_3.rich_text)}</h4>;
                  default:
                    return null;
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotionPrinciplesPage;
